
import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      <img
        src="/images/hero-poster.png"
        alt="Hero section background"
        width="1920"
        height="1080"
        fetchPriority="high"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/40" />
      <div className="relative z-10 text-center px-4 self-end pb-20">
        <h1 className="text-white text-2xl md:text-4xl lg:text-5xl font-cormorant-garamond leading-tight italic tracking-wide font-normal">
          Вневременная элегантность и<br />утонченная роскошь
        </h1>
      </div>
    </section>
  );
};

export default Hero;
